import React, { useState } from "react";
import styles from "./NewProcess.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";

import { RiFileTextLine } from "react-icons/ri";

const NewProcess = () => {
  const dispatch = useDispatch();

  const [processName, setProcessName] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [status, setStatus] = useState("");

  const handleSave = () => {
    console.log({
      processName,
      dueDate,
      status,
    });
  };

  const handleCancel = () => {
    setProcessName("");
    setDueDate("");
    setStatus("");
    
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* Header */}
        <div className={styles.header}>
          <HeadingAndIcon
            icon={<RiFileTextLine />}
            heading="Create a new process"
          />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        {/* Form */}
        <div className={styles.body}>
          <div className={styles.inputGroup}>
            <label>Process Name *</label>
            <input
              type="text"
              placeholder="Enter process name"
              value={processName}
              onChange={(e) => setProcessName(e.target.value)}
              className={styles.input}
            />
          </div>

          <div className={styles.inputGroup}>
            <CalendarInput
              fieldLabel="Due Date*"
              value={dueDate}
              onChange={setDueDate}
            />
          </div>

          <div className={styles.inputGroup}>
            <HeadingAndDropDown
              label="Status *"
              name="status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              options={[
                { label: "Live", value: "live" },
                { label: "Inactive", value: "inactive" },
                { label: "Draft", value: "draft" },
              ]}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className={styles.actions}>
          <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default NewProcess;
